import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { Auth, Tarjet, AddressInterface } from 'src/environments/environment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { User } from 'src/environments/environment.prod';
import { AlertController } from '@ionic/angular';
import * as CryptoJS from 'crypto-js';
import { Globals } from './globals';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public data: User;

  public auth: Auth = {
    email : '', pass : ''
  };

  public notifications: any[] = [];
  public home_message = '';

  public Tarjets: Tarjet[];

  public isLoggedIn: boolean = false;

  public states: any[] = [
    'Nuevo',
    'Aceptado',
    'Llegada Local',
    'Salida local',
    'Entregado',
    'Rechazado',
    'Eliminado',
  ];

  // PARAMS USERS
  public adressesUser: AddressInterface[] = [];
  public adressSelected: number = 0;

  constructor(
    public toastCtrl: ToastController,
    private alert: AlertController,
    private iab: InAppBrowser,
    private storage: NativeStorage,
    public clave: Globals
    ) {}

  async generateToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000
    });
    toast.present();
  }

  async presentAlert(hdr,msg) {
    const alert = await this.alert.create({
      header: hdr,
      message: msg,
      buttons: ['Aceptar']
    });

    await alert.present();
  }

  Whatsap(){
    this.iab.create('https://yadeyaencasa.com/Contact_WhatsApp', '_system');
  }

  getAuth(){
    this.storage.getItem('backup')
        .then(
          data => {
            this.auth = JSON.parse(data['auth']);
            this.data = JSON.parse(data['data']);
            this.isLoggedIn = true;
          },
          error => console.error(JSON.stringify(error))
        );
  }

  async getAuth2(){
    await this.storage.getItem('backup')
        .then(
          data => {
            this.auth = JSON.parse(data['auth']);
            this.data = JSON.parse(data['data']);
            this.isLoggedIn = true;
          },
          error => console.error(JSON.stringify(error))
        );
  }

  promiseGetAuth(){

    return new Promise( (resolve,reject) => {
      this.storage.getItem('backup')
        .then(
          data => {

            this.auth = JSON.parse(data['auth']);
            this.data = JSON.parse(data['data']);
            this.isLoggedIn = true;
            resolve('OK');

          },
          error => reject('error -> ' + JSON.stringify(error))
        ).catch( (er) => reject('catchKO -> ' + JSON.stringify(er)) );
    })
    
  }

  setAuth(param){
    

    if(document.URL.startsWith('http') || document.URL.startsWith('https')){
      this.isLoggedIn=true
      localStorage.setItem('log','true')
      localStorage.setItem('user',CryptoJS.AES.encrypt(JSON.stringify(param),this.clave.secret).toString())
      
      
    
    }else {
      this.storage.setItem('backup',
    { 
      auth: JSON.stringify(this.auth),
      data: JSON.stringify(param)
    })
      .then(
        () => console.log('Stored item! -> length string -> ' + JSON.stringify(param).length),
        error => console.error('Error storing item', error)
      );
    }
  }

  resetAuth(){
    this.storage.clear()
      .then(
      () => {
        this.isLoggedIn = false;
        this.data.token = '';
        this.auth = { email : '', pass : ''};
      },
      error => console.error('Error storing item', error)
    );
  }

  getToken(){ }

}
